<template>
    <div class="pro-form-card">
      <div class="pro-form-header">
        <div class="header-left">
          <v-icon color="#ffa409" class="mr-2">&#xe7ee;</v-icon>
          <div class="titles">
            <h3 class="title">Demande entreprise</h3>
            <p class="subtitle">Recevez un devis ou un questionnaire adapté</p>
          </div>
        </div>
        <div class="header-right">
          <span class="badge">Assuraf Pro Online</span>
          <v-icon color="#0d4e78" class="close-icon" style="cursor:pointer" @click="showCloseConfirmation">&#xe5cd;</v-icon>
        </div>
      </div>
      <h3 style="margin-top: -10px;" v-if="currentStep === 1">Informations sur l’entreprise <span>1/2</span></h3>
       <h3 style="margin-top: -10px;" v-if="currentStep === 2">Coordonnées du responsable <span>2/2</span></h3>

      <div v-if="currentStep === 1" class="mt-5">
          <!-- Bloc Entreprise: affiché pour les demandes pro -->
          <div class="fields">
            <div class="row">
              <div class="col-sm-6">
                <div class="field-group field-default mb-4 mb-sm-0">
                  <label class="field-label">Nom de l’entreprise</label>
                  <input
                    v-model="entreprise_nom"
                    @input="validateField('entreprise_nom')"
                    :class="['field-input', { invalid: !!errors.entreprise_nom }]"
                    placeholder="Ex: Assuraf SA"
                    name="entreprise_nom"
                  >
                  <small v-if="errors.entreprise_nom" class="error-msg">{{ errors.entreprise_nom }}</small>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="field-group field-default mb-4 mb-sm-0">
                  <label class="field-label">NINEA</label>
                  <input
                    v-model="entreprise_ninea"
                    @input="validateField('entreprise_ninea')"
                    :class="['field-input', { invalid: !!errors.entreprise_ninea }]"
                    placeholder="NINEA"
                    name="entreprise_ninea"
                  >
                  <small v-if="errors.entreprise_ninea" class="error-msg">{{ errors.entreprise_ninea }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="fields">
            <div class="row">
              <div class="col-sm-6">
                <div class="field-group field-default mb-4 mb-sm-0">
                  <label class="field-label">Secteur d’activité</label>
                  <input
                    v-model="entreprise_secteur"
                    @input="validateField('entreprise_secteur')"
                    :class="['field-input', { invalid: !!errors.entreprise_secteur }]"
                    placeholder="Ex: BTP, Commerce, Services…"
                    name="entreprise_secteur"
                  >
                  <small v-if="errors.entreprise_secteur" class="error-msg">{{ errors.entreprise_secteur }}</small>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="field-group field-default mb-4 mb-sm-0">
                  <label class="field-label">Chiffre d’affaires (CA)</label>
                  <input
                    v-model="entreprise_ca"
                    @input="validateField('entreprise_ca')"
                    @keypress="onlyNumber"
                    :class="['field-input', { invalid: !!errors.entreprise_ca }]"
                    placeholder="Ex: 150000000"
                    name="entreprise_ca"
                  >
                  <small v-if="errors.entreprise_ca" class="error-msg">{{ errors.entreprise_ca }}</small>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="field-group field-default mb-4 mb-sm-0">
                  <label class="field-label">Effectif</label>
                  <input
                    v-model="entreprise_effectif"
                    @input="validateField('entreprise_effectif')"
                    @keypress="onlyNumber"
                    :class="['field-input', { invalid: !!errors.entreprise_effectif }]"
                    placeholder="Ex: 50"
                    name="entreprise_effectif"
                  >
                  <small v-if="errors.entreprise_effectif" class="error-msg">{{ errors.entreprise_effectif }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Bouton pour passer à l'étape suivante -->
          <div class="actions">
            <button
              @click="currentStep = 2"
              type="button"
              class="wizard-btn next-btn"
              :class="{'next-btn-active': isStep1Complete}"
              :disabled="!isStep1Complete"
            >
              <span class="mr-2">Suivant</span>
              <v-icon>&#xe5c8;</v-icon>
            </button>
          </div>
      </div>

      <div v-if="currentStep === 2" class="mt-5">
         
        <!-- Coordonnées du responsable -->
      <div class="fields">
        <div class="row">
          <div class="col-sm-3">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Nom</label>
              <input
                v-model="responsable_nom"
                @input="validateField('responsable_nom')"
                :class="['field-input', { invalid: !!errors.responsable_nom }]"
                placeholder="Ex: Dupont"
                name="responsable_nom"
              >
              <small v-if="errors.responsable_nom" class="error-msg">{{ errors.responsable_nom }}</small>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Prénom</label>
              <input
                v-model="responsable_prenom"
                @input="validateField('responsable_prenom')"
                :class="['field-input', { invalid: !!errors.responsable_prenom }]"
                placeholder="Ex: Jean"
                name="responsable_prenom"
              >
              <small v-if="errors.responsable_prenom" class="error-msg">{{ errors.responsable_prenom }}</small>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Fonction du responsable</label>
              <input
                v-model="responsable_fonction"
                @input="validateField('responsable_fonction')"
                :class="['field-input', { invalid: !!errors.responsable_fonction }]"
                placeholder="Ex: DG, Responsable RH…"
                name="responsable_fonction"
              >
              <small v-if="errors.responsable_fonction" class="error-msg">{{ errors.responsable_fonction }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Coordonnées du responsable -->
      <div class="fields">
        <div class="row">
          <div class="col-sm-6">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Téléphone</label>
              <div class="phone-input-group">
                <CountryCodeSelect v-model="countryCode" />
                <input
                  v-model="telephone"
                  @input="validateField('telephone')"
                  @keypress="onlyNumber"
                  :class="['field-input', { invalid: !!errors.telephone }, 'phone-number-input']"
                  placeholder="Ex: 761416464"
                  name="telephone"
                >
              </div>
              <small v-if="errors.telephone" class="error-msg">{{ errors.telephone }}</small>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Email</label>
              <input
                v-model="email"
                @input="validateField('email')"
                :class="['field-input', { invalid: !!errors.email }]"
                placeholder="Ex: contact@entreprise.com"
                name="email"
              >
              <small v-if="errors.email" class="error-msg">{{ errors.email }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Type d’assurance souhaitée -->
      <div class="fields">
        <div class="row">
          <div class="col-sm-12">
            <div class="field-group field-default mb-4 mb-sm-0">
              <label class="field-label">Type d’assurance souhaitée</label>
              <select
                v-model="assuranceType"
                @change="validateField('assuranceType')"
                :class="['field-select', { invalid: !!errors.assuranceType }]"
                name="assuranceType"
              >
                <option disabled value="">Choisir un type d’assurance</option>
                <option>RC Pro</option>
                <option>Multirisque Professionnelle</option>
                <option>Flotte Auto</option>
                <option>TRC</option>
                <option>Caution</option>
                <option>RC Scolaire</option>
              </select>
              <small v-if="errors.assuranceType" class="error-msg">{{ errors.assuranceType }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Zone de message libre -->
      <div class="fields">
        <div class="row">
          <div class="col-sm-12">
            <div class="field-group field-default">
              <label class="field-label">Message</label>
              <textarea
                v-model="message"
                @input="validateField('message')"
                :class="['field-input', { invalid: !!errors.message }]"
                rows="4"
                placeholder="Décrivez votre besoin, votre activité, vos attentes…"
              ></textarea>
              <small v-if="errors.message" class="error-msg">{{ errors.message }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Bouton d'envoi -->
      <div class="actions step2-actions">
        <button
              @click="currentStep = 1"
              type="button"
              class="wizard-btn back-btn"
            >
             <v-icon>&#xe5c4;</v-icon>
              <span class="ml-2">Retour</span>
            </button>
        <button
          @click="sending_message"
          type="button"
          class="ml-3 wizard-btn send-btn"
          :disabled="hasErrors || !isFormComplete"
        >
          <v-icon class="send-icon">&#xe163;</v-icon>
          <span>Envoyer ma demande</span>
        </button>
      </div>
      </div>
      <!-- Dialog de confirmation de fermeture -->
    <v-dialog v-model="confirmCloseDialog" max-width="400">
      <v-card style="border-radius: 20px;">
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Êtes-vous sûr de vouloir annuler la demande?</v-card-text>
          <v-spacer></v-spacer>
          <div class="actions step2-actions">
            <button
              @click="cancelClose"
              type="button"
              class="wizard-btn back-btn ml-3 mb-3"
            >
             <v-icon>&#xe5c4;</v-icon>
              <span class="ml-2">Annuler</span>
            </button>
             <button
          @click="confirmClose"
          type="button"
          class="wizard-btn send-btn-confirm mr-3 mb-3"
        >
          <v-icon class="send-icon">&#xe86c;</v-icon>
          <span>Confirmer</span>
        </button>
          </div>
           
          <!-- <v-btn style="border-radius: 10px;" color="grey darken-1" text @click="cancelClose">Annuler</v-btn>
          <v-btn style="border-radius: 10px;" color="#ffa409" @click="confirmClose">Confirmer</v-btn> -->
      </v-card>
    </v-dialog>
    </div>

</template>

<script>
import Api from '../../services/Api';
import CountryCodeSelect from '../../views/CountryCodeSelectProOnline.vue'
import IntlNumber from '../../common/intlNumber.json'
import { parsePhoneNumberFromString } from 'libphonenumber-js'


const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};

export default {
    props: {
        subject: { type: String, default: '' }
    },
    data: () => ({
        countryCode : '+221',
        sujet: 'Assurance Pro',
        currentStep: 1,
        telephone: '',
        email: '',
        message: '',
        responsable_nom: '',
        responsable_prenom: '',
        responsable_fonction: '',
        assuranceType: '',
        entreprise_nom: '',
        entreprise_ninea: '',
        entreprise_secteur: '',
        entreprise_ca: '',
        entreprise_effectif: '',
        confirmCloseDialog: false,
        errors: {
          entreprise_nom: null,
          entreprise_ninea: null,
          entreprise_secteur: null,
          entreprise_ca: null,
          entreprise_effectif: null,
          responsable_nom: null,
          responsable_prenom: null,
          telephone: null,
          email: null,
          assuranceType: null,
          message: null,
        },
        ToastTabError: { type: 'error' },
          ToastTabSucess: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'success',
          className: 'custom-success-class'
        }, // Customized options for success toast
        ToastTabError: {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 4000,
          fitToScreen: true,
          type: 'error'
        }, 
    }),

    components: {
        CountryCodeSelect
    },
    
    computed: {
        isPro() { 
            return this.sujet === 'Assurance Pro' 
        },
        hasErrors() { 
            return Object.values(this.errors).some(v => !!v) 
        },
        isStep1Complete() {
            // Variante stricte (en tenant compte des erreurs) :
            // return !!this.entreprise_nom &&
            //        !!this.entreprise_ninea &&
            //        !!this.entreprise_secteur &&
            //        !!this.entreprise_ca &&
            //        !!this.entreprise_effectif &&
            //        !this.errors.entreprise_nom &&
            //        !this.errors.entreprise_ninea &&
            //        !this.errors.entreprise_secteur &&
            //        !this.errors.entreprise_ca &&
            //        !this.errors.entreprise_effectif
        
            // Variante simple (présence des champs seulement) :
            return !!this.entreprise_nom &&
                !!this.entreprise_ninea &&
                !!this.entreprise_secteur &&
                !!this.entreprise_ca &&
                !!this.entreprise_effectif
        },
        isStep2Complete() {
        const base =
            !!this.telephone && !!this.email && !!this.message &&
            !!this.responsable_fonction &&
            !this.errors.telephone && !this.errors.email && !this.errors.message
    
        if (!this.isPro) return base
        return base && !!this.assuranceType && !this.errors.assuranceType
        },
        isFormComplete() {
            return this.currentStep === 1 ? this.isStep1Complete : this.isStep2Complete
        }
    },

    watch: {
    countryCode() {
      // Revalider le téléphone lorsqu’on change l’indicatif
      this.validateField('telephone')
    }
  },
    
    methods: {
     onlyNumber($event) {
        let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },
        validEmail(email) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        showCloseConfirmation() {
          this.confirmCloseDialog = true
        },
        confirmClose() {
          this.confirmCloseDialog = false
          this.$emit('close')
          this.resetForm()
        },
        cancelClose() {
          this.confirmCloseDialog = false
        },
        subjectSelectControl() {
          // Revalider lorsqu'on change de sujet
          this.runValidation()
        },
        // onlyNumber(evt) {
        //     const charCode = evt.which ? evt.which : evt.keyCode
        //     if (charCode < 48 || charCode > 57) {
        //         evt.preventDefault()
        //     }
        // },
        validateProFields() {
            if (!this.entreprise_nom) { this.$toasted.show('Le nom de l’entreprise est obligatoire', this.ToastTabError); return false; }
            if (!this.entreprise_ninea) { this.$toasted.show('Le NINEA est obligatoire', this.ToastTabError); return false; }
            if (!this.entreprise_secteur) { this.$toasted.show('Le secteur d’activité est obligatoire', this.ToastTabError); return false; }
            if (!this.entreprise_ca) { this.$toasted.show('Le chiffre d’affaires est obligatoire', this.ToastTabError); return false; }
            if (!this.entreprise_effectif) { this.$toasted.show('L’effectif est obligatoire', this.ToastTabError); return false; }
            if (!this.responsable_fonction) { this.$toasted.show('La fonction du responsable est obligatoire', this.ToastTabError); return false; }
            if (!this.assuranceType) { this.$toasted.show('Veuillez choisir un type d’assurance', this.ToastTabError); return false; }
            return true;
        },
        validateField(field) {
          const val = this[field]
          switch (field) {
            case 'entreprise_nom':
            case 'entreprise_ninea':
            case 'entreprise_secteur':
              this.errors[field] = val ? null : 'Champ obligatoire'
              break
            case 'entreprise_ca':
              this.errors[field] = val && /^\d+$/.test(val) ? null : 'CA numérique obligatoire'
              break
            case 'entreprise_effectif':
              this.errors[field] = val && /^\d+$/.test(val) ? null : 'Effectif numérique obligatoire'
              break
            case 'responsable_nom':
            case 'responsable_prenom':
              this.errors[field] = val ? null : 'Champ obligatoire'
              break
            case 'telephone':
              const { valid, error } = validatePhoneWithIndicatif(this.telephone, this.countryCode)
              this.errors[field] = valid ? null : (error || 'Téléphone invalide')
              break
            case 'email':
              this.errors[field] = val && this.validEmail(val) ? null : 'Email invalide'
              break
            case 'assuranceType':
              this.errors[field] = this.isPro && !val ? 'Sélection obligatoire' : null
              break
            case 'message':
              this.errors[field] = val ? null : 'Message obligatoire'
              break
          }
        },
        runValidation() {
          const fields = ['telephone','email','message']
          if (this.isPro) {
            fields.push('entreprise_nom','entreprise_ninea','entreprise_secteur','entreprise_ca','entreprise_effectif','responsable_fonction','assuranceType')
          }
          fields.forEach(f => this.validateField(f))
        },
        sending_message() {
            // Validation rapide avant envoi
            this.runValidation()
            if (this.hasErrors || !this.isFormComplete) {
              this.$toasted.show('Veuillez corriger les champs en rouge', this.ToastTabError)
              return
            }

            let phoneNumber = (this.countryCode + this.telephone).substring(1)

            let sendingData = {
                sujet: this.sujet,
                entreprise_nom: this.entreprise_nom,
                entreprise_ninea: this.entreprise_ninea,
                entreprise_secteur: this.entreprise_secteur,
                entreprise_ca: this.entreprise_ca,
                entreprise_effectif: this.entreprise_effectif,
                responsable_nom: this.responsable_nom,
                responsable_prenom: this.responsable_prenom,
                responsable_telephone : phoneNumber,//`${this.countryCode}${this.telephone}`,
                responsable_email : this.email,
                responsable_fonction: this.responsable_fonction,
                assuranceType: this.assuranceType,
                message: this.message,
                plateforme:"Front",
            }
            console.log('sendingData',sendingData)

            Api().post('/assurafpro/create', sendingData)
                .then(response => {
                  console.log('response',response)
                    this.$toasted.show('Demande envoyée avec succès', this.ToastTabSucess);
                    this.$emit('close')

                    this.resetForm();
                })
                .catch(error => {
                    this.$toasted.show('Erreur lors de l\'envoi de la demande', this.ToastTabError);
                    this.$emit('close')
                    this.resetForm();
                });
        },
        resetForm() {
                    this.currentStep = 1;
                    this.telephone = '';
                    this.email = '';
                    this.message = '';
                    this.responsable_nom = '';
                    this.responsable_prenom = '';
                    this.responsable_fonction = '';
                    this.assuranceType = '';
                    this.entreprise_nom = '';
                    this.entreprise_ninea = '';
                    this.entreprise_secteur = '';
                    this.entreprise_ca = '';
                    this.entreprise_effectif = '';
                    // Reset errors
                    this.errors = {
                        entreprise_nom: null,
                        entreprise_ninea: null,
                        entreprise_secteur: null,
                        entreprise_ca: null,
                        entreprise_effectif: null,
                        responsable_nom: null,
                        responsable_prenom: null,
                        telephone: null,
                        email: null,
                        assuranceType: null,
                        message: null,
                    };
                }
    },
    created() {
        // Préremplir le sujet depuis la prop ou la route
        const subjectFromProp = this.subject || ''
        if (subjectFromProp) {
            this.sujet = subjectFromProp
        } else {
            const subjectFromRoute = (this.$route.params && this.$route.params.subject)
                ? decodeURIComponent(this.$route.params.subject)
                : '';
            if (subjectFromRoute) {
                this.sujet = subjectFromRoute;
            }
        }
    }
   
}
</script>

<style scoped>
 ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 12px;
  }
.pro-form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(13, 78, 120, 0.15);
  padding: 20px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}

.pro-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.12);
  margin-bottom: 16px;
}

.header-left {
  display: flex;
  align-items: center;
}

.titles .title {
  margin: 0;
  font-size: 18px;
  color: #0d4e78;
  font-weight: 700;
  line-height: 1.2;
}

.titles .subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #6b7c8a;
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;          /* assure l’alignement vertical */
  align-items: center;
}

.close-icon {
  margin-left: 0;                /* neutralise l’ancienne marge ml-3 */
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;             /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}
.header-right {
  display: inline-flex;          /* aligne badge et icône sur une ligne */
  align-items: center;
  gap: 10px;                     /* espace entre badge et X */
  white-space: nowrap;           /* évite le retour à la ligne sur mobile */
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;          /* assure l’alignement vertical */
  align-items: center;
}

.close-icon {
  margin-left: 0;                /* neutralise l’ancienne marge ml-3 */
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;             /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}
.fields {
  margin-bottom: 10px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.col-sm-12 { flex: 1 1 100%; }
.col-sm-6  { flex: 1 1 calc(50% - 12px); min-width: 260px; }
.col-sm-3  { flex: 1 1 calc(25% - 12px); min-width: 200px; }

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-weight: 600;
  color: #0d4e78;
  font-size: 13px;
}

.field-input,
.field-select,
textarea.field-input {
  width: 100%;
  height: 45px;
  border: 1px solid rgba(13, 78, 120, 0.22);
  border-radius: 10px;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  background: #fff;
  color: #1c2b36;
  font-size: 14px;
}

.field-input:focus,
.field-select:focus,
textarea.field-input:focus {
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.18);
}

.success-alert {
  border-color: rgba(13, 78, 120, 0.22) !important;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.send-btn {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
}
.send-btn-confirm {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
  height: 50px;
  width: 150px;
}

.next-btn-active {
  /* background: #ffa409; */
  color: #ffa409;
  font-weight: 500;
  /* border-color: #ffa409; */
}

.step2-actions {
  justify-content: space-between;
}

.back-btn {
  /* background-color: #f5f5f5; */
  color: #333;
}

/* Responsive */
@media (max-width: 768px) {
  .pro-form-card {
    padding: 14px;
    border-radius: 14px;
  }
  .titles .title {
    font-size: 16px;
  }
  .titles .subtitle {
    font-size: 12px;
  }
  .col-sm-6, .col-sm-3 {
    flex: 1 1 100%;
  }
  .actions {
    justify-content: flex-end;
  }
  .send-btn {
    width: 100%;
  }
  .next-btn {
    min-width: 120px;
  }
}
.send-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
  padding: 10px 24px;
  font-size: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  transition: transform 0.05s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}
.send-btn:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
}
.send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
.send-icon {
  color: #7a4e00; /* icône brune comme sur l’image */
  font-size: 26px;
}

@media (max-width: 768px) {
  .send-btn {
    width: 100%;
    height: 56px;
    justify-content: center;
  }
}
.phone-input-group {
  display: flex;
  align-items: center;
  gap: 0;
}
.phone-number-input {
  border-radius: 0 10px 10px 0;
  /* height: 40px; */
}
</style>